import { AbstractHook } from '@hooks/abstraction';
import { PersonService } from '../services/person.service';
import { PersonResponse } from '../services/responses/person.response';

export class PersonHook extends AbstractHook<PersonResponse, PersonService> {}
